import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import logoNavy from '../../assets/logo-navy.png';

export function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  // Supabase sends the session via hash fragment; wait for it to be parsed
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true);
      else setError('Invalid or expired reset link. Please request a new one.');
    });
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    if (err) { setError(err.message); setLoading(false); return; }
    await supabase.auth.signOut();
    navigate('/login', { replace: true, state: { notice: 'Password updated. Please sign in.' } });
  }

  return (
    <div className="auth-screen" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <div className="auth-panel-right" style={{ maxWidth: 480 }}>
        <div className="auth-card">
          <div className="auth-logo">
            <img src={logoNavy} alt="Apex Elite" style={{ height: 40 }} />
          </div>
          <h1 className="auth-title">Set new password</h1>
          <p className="auth-subtitle">Enter a new password for your account.</p>

          {!ready ? (
            <p className="form-error" style={{ marginTop: 16 }}>{error || 'Verifying link…'}</p>
          ) : (
            <form className="form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input
                  className="form-input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Min. 6 characters"
                  required
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input
                  className="form-input"
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Re-enter password"
                  required
                />
              </div>
              {error && <p className="form-error">{error}</p>}
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? 'Saving…' : 'Update Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
